<template>
  <v-app>
    <!-- <v-app-bar class="show-on-mobile white elevation-1" fixed dense dark app>
        <v-toolbar-title class="black--text">Vendor</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar> -->
    <v-main class="main-bg" style="background-color: #ececec">
      <v-container fill-height fluid>
        <v-row align="center" justify="center">
          <v-spacer></v-spacer>
          <v-col cols="12" md="8">
            <v-card elevation="0" class="py-14">
              <v-row>
                <v-col cols="12" class="text-center">
                  <v-icon size="60" color="#BE0000"
                    >mdi-alert-circle-outline</v-icon
                  >
                </v-col>
                <v-col cols="12" class="text-center">
                  <b class="error-text">พบข้อผิดพลาด</b>
                  <br/>
                  <span v-if="errorDescription" class="error-text">{{ errorDescription }}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
    </v-main>
    <!-- <Footer></Footer> -->
    <!-- <v-footer absolute padless color="rgb(0 0 0 / 30%)">
        <v-col class="text-right white--text" cols="12">
          เหอะๆ
        </v-col>
      </v-footer> -->
  </v-app>
</template>

  <script>
// import Footer from "@/components/Footer.vue";
import { ErrorStatusList } from "@/common/api/config";

export default {
  components: {
    // Footer,
  },
  data() {
    return {
      errorDescription: '',
    };
  },
  created() {
    const errorCode = this.$route.params.code;
    if (errorCode) {
      this.errorDescription = ErrorStatusList.find(v => v.code === errorCode).display;
      console.log('errorDescription', this.errorDescription);
    }
  },
};
</script>
<style lang="scss" scope>
  .error-text {
    color: black;
    font-size: 20px;
  }
</style>